import React, { useState, useEffect } from "react";
import "./Hero.css";
import { Link } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";


import hero1 from "../Assets/hero1.jpg";
import hero2 from "../Assets/hero2.jpg";
import hero3 from "../Assets/hero3.jpg";
import hero4 from "../Assets/hero4.jpg";

const slides = [
  { id: 1, image: hero1 },
  { id: 2, image: hero2 },
  { id: 3, image: hero3 },
  { id: 4, image: hero4 },
];

const Hero = ({ onLoaded }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Preload all carousel images
    let loadedCount = 0;

    slides.forEach((slide) => {
      const img = new Image();
      img.onload = () => {
        loadedCount++;
        if (loadedCount === slides.length) {
          setIsLoading(false);
          onLoaded?.();
        }
      };
      img.onerror = () => {
        loadedCount++;
        if (loadedCount === slides.length) {
          setIsLoading(false);
          onLoaded?.();
        }
      };
      img.src = slide.image;
    });
  }, [onLoaded]);

  if (isLoading) {
    return null;
  }

  return (
    <div className="hero">
      <div className="hero-left">
        <h2>Serving Adults with Intellectual Disabilities</h2>

        <p>
          Rodgers Consulting Services Inc. provides personalized training and
          support to help consumers experience a more comfortable lifestyle with
          greater independence and strengthened abilities.
        </p>

        <div className="hero-btn">
          <Link to="/about">
            <h5 id="hero-about">Learn More</h5>
          </Link>
        </div>
      </div>

      <Carousel
        className="hero-carousel"
        interval={5000}
        pause={false}
        fade
        indicators={false}
        controls={false}
        touch={false}
        ride="carousel"
      >
        {slides.map((slide) => (
          <Carousel.Item key={slide.id}>
            <img className="hero-image" src={slide.image} alt="hero" />

            <div className="carousel-caption-custom">
              <h2>Service.</h2>
              <h2>Training.</h2>
              <h2>Growth.</h2>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default Hero;
